import React from "react";
import { Grid } from "@material-ui/core";

import { EXECUTION_BRIEF_HOOK } from "../../../pages/execution-brief/types/execution-brief-template.interface";
import { EXECUTION_TEMPLATE } from "../../../types/templates/execution-brief/execution-brief-template.enum";
import { TemplateGrid } from "../../../components/template-grid/template-grid.component";
import { TemplateName } from "../../../types/templates/template-name";
import { UserGroup } from "../../../constants/types";
import { useExecutionBriefTemplateOptions } from "../../../pages/execution-brief/types/execution-brief-template.hooks";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { TextField } from "../../forms/fields/text-field/text-field.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";

import {
  DEALER_STORE_TYPE,
  IS_INVENTORY_AVAILABLE,
  IS_REGIONAL,
  LANGUAGES,
  MERCH_OWNERS,
  STORE_NUMBER,
} from "../constants";

import { IExecutionBriefTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const ExecutionBriefDealerAdvertisingTemplate = (props: IExecutionBriefTemplate) => {
  const { languagesOptions, regionsOptions, storeTypeOptions } = useExecutionBriefTemplateOptions(
    [
      EXECUTION_BRIEF_HOOK.LANGUAGES,
      EXECUTION_BRIEF_HOOK.REGIONS,
      EXECUTION_BRIEF_HOOK.STORE_TYPES,
    ],
    EXECUTION_TEMPLATE.DEALER_ADVERTISING
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_INVENTORY_AVAILABLE.TITLE}
            name={IS_INVENTORY_AVAILABLE.ID}
            subTitle={TemplateName.ExecutionBrief.DealerAdvertising}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <TemplateGrid container spacing={3}>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <TextField
                form={props.form}
                label={STORE_NUMBER.TITLE}
                name={STORE_NUMBER.ID}
                required
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
          <Grid item xs={12} md={6}>
            <BorderedBlock>
              <SelectField
                form={props.form}
                label={DEALER_STORE_TYPE.TITLE}
                name={DEALER_STORE_TYPE.ID}
                options={storeTypeOptions}
                placeholder="Select Dealer Store Type"
                required
                userPermissions={props.userPermissions}
              />
            </BorderedBlock>
          </Grid>
        </TemplateGrid>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <SelectField
            form={props.form}
            label={LANGUAGES.TITLE}
            multiple
            name={LANGUAGES.ID}
            options={languagesOptions}
            placeholder="Select Language"
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            groupFilter={UserGroup.MERCH_OWNERS}
            label={MERCH_OWNERS.TITLE}
            name={MERCH_OWNERS.ID}
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_REGIONAL.TITLE}
            name={IS_REGIONAL.ID}
            userPermissions={props.userPermissions}
          >
            <SelectField
              form={props.form}
              label="Regions"
              multiple
              name="regions"
              options={regionsOptions}
              placeholder="Select Region"
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
